var map = {
	"./Statistics.svg": "67c3",
	"./archive-checked.svg": "a86e",
	"./archive.svg": "b58d",
	"./bid.svg": "20f4",
	"./brifecase.svg": "966d",
	"./cards-checked.svg": "36be",
	"./cards.svg": "1fa0",
	"./main-checked.svg": "de32",
	"./main.svg": "cb61",
	"./messages.svg": "403d",
	"./notifications.svg": "e5a2",
	"./profile-checked.svg": "66bd",
	"./profile.svg": "7bcf",
	"./settings-checked.svg": "d4c7",
	"./settings.svg": "e734"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2c54";